var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBiometricIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116.375,
    height: 116.375,
    viewBox: "0 0 116.375 116.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "biometric-icon",
    transform: "translate(-3 -0.113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Export",
    transform: "translate(3 0.488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13252",
    "data-name": "Path 13252",
    d: "M0,0H116V116",
    fill: "#fff",
    stroke: "#202020",
    strokeWidth: 0.75,
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_20",
    "data-name": "Layer 20",
    transform: "translate(13.987 19.249)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9902",
    "data-name": "Rectangle 9902",
    width: 93.253,
    height: 76.708,
    rx: 16,
    fill: "#deebfe",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24737",
    "data-name": "Group 24737",
    transform: "translate(0 4.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24736",
    "data-name": "Group 24736",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24735",
    "data-name": "Group 24735",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137601",
    "data-name": "Path 137601",
    d: "M96.571,37.239l-.381,2.514-.438,2.924L91.779,69.312a4.816,4.816,0,0,1-5.451,4.039l-48.168-7.2-11.3-1.7-15.041-2.2A4.774,4.774,0,0,1,7.8,56.813l6.878-46.149a4.8,4.8,0,0,1,5.437-4.025l55.587,8.3L86.2,16.511l8.474,1.257A4.8,4.8,0,0,1,98.7,23.2l-.932,6.214",
    transform: "translate(-6.296 -5.166)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137602",
    "data-name": "Path 137602",
    d: "M39.78,24.167c.113-.07.1,0,.212-.113v.1h.114a.142.142,0,0,0-.156-.127v-.07C39.949,23.885,39.794,24.026,39.78,24.167Z",
    transform: "translate(6.912 1.988)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137603",
    "data-name": "Path 137603",
    d: "M39.44,23.8Z",
    transform: "translate(6.771 1.931)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137604",
    "data-name": "Path 137604",
    d: "M42.437,24.689a.212.212,0,0,1,0-.1C42.423,24.66,42.311,24.675,42.437,24.689Z",
    transform: "translate(7.982 2.257)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137605",
    "data-name": "Path 137605",
    d: "M39.44,23.78Z",
    transform: "translate(6.771 1.924)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137606",
    "data-name": "Path 137606",
    d: "M46.212,23.08a.127.127,0,0,0,0,.085h0Z",
    transform: "translate(9.56 1.635)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137607",
    "data-name": "Path 137607",
    d: "M42.91,22.8Z",
    transform: "translate(8.202 1.519)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137608",
    "data-name": "Path 137608",
    d: "M39.432,23.805c0,.2.2.2.3.325s-.127,0-.127,0a.226.226,0,0,0,.1.226h0s.127,0,.142.085H39.69a2.176,2.176,0,0,0,.268.113H39.8a.438.438,0,0,0,.226.085c-.1,0,0-.1,0-.127h0c.085-.183-.2-.142-.268-.268h.127a1.019,1.019,0,0,0,.692.438h0v.282h.1a.268.268,0,0,0,.085.212l.142-.085v.085h-.255c0,.085.1,0,.156,0a.2.2,0,0,0,0,.1l.142-.142v-.014c0-.029,0,.142.1.085a.085.085,0,0,1,0,.085s.169,0,.212-.085.212,0,.183.169a.24.24,0,0,1,.183-.113c-.142.169.2,0,.142.24.1-.155.282,0,.438-.1h0s.085.07.127.113.156-.155.24-.226c0,.142-.085.155-.085.282,0-.113.183-.085.169-.183s0,0,0,.169c0-.169,0,0,.142-.113s0,.155.127.127v-.155c0-.056,0,.1.085.183s.169-.142.24-.127h0a1.075,1.075,0,0,0,.4-.07.339.339,0,0,1,0-.169h.113c0,.127-.085,0-.1.113s.255-.1.325,0-.2,0-.1.127h-.127v.183c0,.183.2,0,.354,0s0-.1,0-.155.127.325.325.2.1-.226.212-.127V25.7c.155,0,.127-.183.268-.07s-.127,0-.1,0,.085-.07.169,0v.113h.551c.183,0,0,.07,0,.113a1.324,1.324,0,0,1,.72.2l.1-.1h0a.692.692,0,0,1,.621,0h0c.127,0,.169-.2.282-.085h0c.282.085.593,0,.791.212,0-.155.268.1.306-.113.142.127.1.155.311.255s.113-.113.183-.127v.1l.113-.1v.142h0a.113.113,0,0,1,0-.1.255.255,0,0,1,.255.169h.271l-.1.07c-.1.07,0,.113.156,0s0,0,0-.085.2.1.3.085v.07h.621c-.07,0,0-.169,0-.169v.113s-.07,0,0-.127,0,.142,0,.169h.1v.085c0,.085.155.142.226,0h.494c.169,0,.085,0,.142-.142a1.3,1.3,0,0,0,.407.155c.113,0,0-.07.1-.127s.155.1,0,.155a1,1,0,0,0,.611-.127s-.085,0-.085-.07.142,0,.142,0h0a3.8,3.8,0,0,1,.537-.282c.183-.113.339-.3.3-.466h0a2.527,2.527,0,0,0,0-.325c0-.127,0,.1.127,0-.127-.339,0-.565-.24-.776a.545.545,0,0,0-.24-.452,4.012,4.012,0,0,1-.509-.306v.07c-.1,0-.085,0-.113-.085s0,0,0,.1a5.07,5.07,0,0,1-1.324-.381c-.155,0-.155.3-.339.113l.085-.1c-.354.07-.677-.127-1.031-.07h-.279c-.014,0,0,0,0-.1s-.183.07-.212,0h-.183a.763.763,0,0,1-.325-.07c-.085-.07-.212-.085-.255,0,0-.155-.183-.169-.282-.1s0-.07,0-.127-.169,0-.169.085c-.127-.212-.353.1-.407-.155a4.775,4.775,0,0,1-.763,0c0-.155.268,0,.282-.127-.24,0-.381.127-.611,0s0-.07,0-.085c-.226,0-.424-.085-.636,0h-.1c0,.113-.183.2-.2.24.1-.183-.183-.07,0-.325a.113.113,0,0,0-.07.1v-.1c-.142,0-.1.1-.226.07s0,0,0-.07-.156.113-.255.07h0c-.183,0-.339.127-.537,0,.085-.142,0,0,0-.183H44.5v.07c-.1,0-.2.07-.268,0h.452c-.1,0,0,.169-.127.113s-.1,0-.142-.1-.1.07-.169,0,0-.142,0-.169-.226,0-.306.113a.226.226,0,0,0,0-.113v-.02c0-.113,0,.183-.127.085h-.454c-.142,0,.142,0,.1-.127s-.452.085-.65,0h0c0,.183-.127-.113-.24,0s0-.1,0-.085a4.438,4.438,0,0,1-.509,0h0a1.172,1.172,0,0,0-.3-.085s-.085,0,0,.1c-.24-.306-.537.07-.749-.2H40.8v.113a.226.226,0,0,1-.155.07c.1,0,0-.127,0-.183v.085c0,.085,0,.155-.183,0h0s-.1.085-.155.085,0,0,0-.127-.127.212-.24.156.085,0,.113-.1a.183.183,0,0,0-.2,0h-.172c0,.268-.2.183-.183.407,0-.212,0-.085-.127-.155s-.113,0-.127,0a.2.2,0,0,0-.1.255c.056.169,0,.085-.113,0s0,0,.1,0S39.263,23.536,39.432,23.805Zm.268.523a.113.113,0,0,1,.1,0v.085ZM45.659,25.856Zm.127,0h0v.07Zm-4.392-3.149v.085h0s-.043-.056,0-.07Zm-1.723.961v.085h-.1Z",
    transform: "translate(6.638 1.22)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137609",
    "data-name": "Path 137609",
    d: "M41.86,24.65Z",
    transform: "translate(7.769 2.282)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137610",
    "data-name": "Path 137610",
    d: "M39.73,24Z",
    transform: "translate(6.891 2.015)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137611",
    "data-name": "Path 137611",
    d: "M39.77,23.93V24h.085Z",
    transform: "translate(6.908 1.985)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137612",
    "data-name": "Path 137612",
    d: "M46.094,25.2V25.17l-.014.029Z",
    transform: "translate(9.509 2.496)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137613",
    "data-name": "Path 137613",
    d: "M39.58,22.62Z",
    transform: "translate(6.829 1.445)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137614",
    "data-name": "Path 137614",
    d: "M44.31,22.842Z",
    transform: "translate(8.779 1.534)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137615",
    "data-name": "Path 137615",
    d: "M42.91,22.807h.07S42.924,22.75,42.91,22.807Z",
    transform: "translate(8.202 1.512)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137616",
    "data-name": "Path 137616",
    d: "M45.86,23.02Z",
    transform: "translate(9.418 1.61)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137617",
    "data-name": "Path 137617",
    d: "M39.689,24.064l.014-.014H39.66Z",
    transform: "translate(6.862 2.035)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137618",
    "data-name": "Path 137618",
    d: "M39.345,23.7h0v-.2A.285.285,0,0,0,39.345,23.7Z",
    transform: "translate(6.724 1.811)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137619",
    "data-name": "Path 137619",
    d: "M42.3,22.61l-.043.07.1-.014Z",
    transform: "translate(7.934 1.441)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137620",
    "data-name": "Path 137620",
    d: "M61.024,32.356c.127,0,.3.113.325,0s-.169-.085-.354-.085-.127-.127-.1-.155-.142-.113-.226,0a1,1,0,0,0,.407.282S61.037,32.356,61.024,32.356Z",
    transform: "translate(15.524 5.337)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137621",
    "data-name": "Path 137621",
    d: "M61.26,33.263a.352.352,0,0,0,0-.113v.1Z",
    transform: "translate(15.767 5.786)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137622",
    "data-name": "Path 137622",
    d: "M55.28,31a.354.354,0,0,1,0,.1C55.323,31,55.576,31,55.28,31Z",
    transform: "translate(13.302 4.9)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137623",
    "data-name": "Path 137623",
    d: "M61.23,33.29v-.07h0Z",
    transform: "translate(15.754 5.815)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137624",
    "data-name": "Path 137624",
    d: "M44.392,31.565a.382.382,0,0,0-.142-.085h0Z",
    transform: "translate(8.754 5.098)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137625",
    "data-name": "Path 137625",
    d: "M19.706,5.937c0-.255-.1-.611-.178-.611a.7.7,0,0,1,0,.142c0-.07,0-.07.061,0s0,.3,0,.3a.846.846,0,0,0,0-.127c-.085.155.061.523,0,.8L19.539,6.3a1.634,1.634,0,0,0-.033-.91.7.7,0,0,0-.457-.5h0a1.315,1.315,0,0,0,0-.169H19.1l.068-.1h-.119c0-.07,0-.142-.144-.226h-.169l-.051-.085h.144c-.076-.1-.127,0-.183,0a.132.132,0,0,0-.068-.1l-.169.113c0-.07.085-.113,0-.169s.061.156-.068.169,0-.142-.144-.1,0-.07.051-.085a1.5,1.5,0,0,0-.263,0c-.051,0-.279,0-.263-.2a.349.349,0,0,1-.229.07c.153-.142-.279-.07-.229-.268-.11.142-.373,0-.56,0h.051a.714.714,0,0,1-.183-.142c0,.127-.183.127-.28.183-.11-.155.085-.142.061-.268,0,.1-.22,0-.183.155s-.085,0-.119-.183c0,.155-.093,0-.178.085s0-.169-.178-.155.068-.1.068-.1c-.153,0-.085.113-.119.183-.183,0-.076-.127-.136-.2s-.212.1-.306.07h0c-.136.07-.367-.085-.517,0h0a.462.462,0,0,1,0,.183h-.153a.042.042,0,0,0,.068,0h-.076c-.051-.142.1,0,.11-.113a1.065,1.065,0,0,1-.424,0c0-.127.263,0,.127-.113l.161.085c-.11-.226.1,0,0-.2s-.254,0-.466-.085c-.061,0,0,.1-.051.155-.322,0-.22-.354-.458-.255-.068,0-.1.2-.263.085l.068-.127c-.212,0-.136.169-.356,0H12.9V2.869H12.15s.068,0,0-.113a2.823,2.823,0,0,1-.975-.325l-.119.07s-.051,0,0-.07c-.119-.07,0,0-.076.085s-.085-.085,0-.1a1.235,1.235,0,0,1-.848-.127H10.1c-.169-.085-.22.155-.367,0h0a3.842,3.842,0,0,1-1.051-.4c-.068.142-.367-.156-.407,0a1.528,1.528,0,0,0-.432-.306c-.085,0-.136.1-.237.085v-.1l-.144.07L7.4,1.5H7.306s.068.07.061.1a.41.41,0,0,1-.347-.212h-.2c-.2,0,0-.127-.2-.07V1.4a.706.706,0,0,0-.407-.142v-.07c-.254-.07-.542-.1-.848-.169.1.07.068.183,0,.183V1.076c-.061,0,.085.07,0,.127s-.068-.155,0-.169H5.231V.949c0-.085-.212-.169-.306-.07h0A1.105,1.105,0,0,1,4.272.752c0,.1-.1,0-.183.127a2.694,2.694,0,0,0-.56-.255c-.144,0-.042.085-.119.127S3.173.484,3.318.484a2.866,2.866,0,0,0-.645,0s.068.07.051.085a.094.094,0,0,1-.119-.1h0C2.238.467,1.817,0,1.52.127h-.3c-.136,0,.085,0,0-.127A.828.828,0,0,0,.317.466,1.171,1.171,0,0,0,0,1.412,3.356,3.356,0,0,0,.257,2.585v-.07c.093.07.068.156.127.255s-.068-.155,0-.127a.947.947,0,0,0,.542.3l.458.155.907.353c.22.07.153-.282.424,0l-.093.1c.458,0,.917.226,1.365.226H3.912c-.076,0,.339.085.347,0s0,0,.051.113.237,0,.279,0h0s.279.085.229,0c.161.085.322,0,.45.127s.272.113.314,0c0,.155.279.2.39.155,0,0,.085.07,0,.127.119,0,.237,0,.22-.07.2.255.45,0,.55.24H7.76c0,.142-.356-.085-.356.085a2.108,2.108,0,0,1,.788,0H8.107c.314,0,.585.155.848.142h.009c-.076-.127.229-.169.245-.212-.11.183.254.113.093.339a.074.074,0,0,0,.076-.085c-.009-.085.068,0,0,.1.2,0,.127-.085.306,0-.03,0-.056.038-.068.085a.33.33,0,0,1,.331,0h0a1.757,1.757,0,0,1,.712,0c-.093.127.085.07.085.2h.593l-.127-.085c.136,0,0-.169.169-.085a.23.23,0,0,1,.183.127h0a.219.219,0,0,1,.229,0v.177a1.743,1.743,0,0,0,.39,0,.2.2,0,0,0,0,.113l.068-.085c.051,0,.061,0,.042.113.178,0-.042-.169.169,0H12.41a2.233,2.233,0,0,1,.612.142c0,.142-.178,0-.119.113a4.3,4.3,0,0,1,.848.085h0c.051-.169.2.142.339.1h0a2.288,2.288,0,0,0,.673,0h0a1.924,1.924,0,0,0,.407.142s.1,0,.068-.085c.339.354.712,0,1.018.339h.212c0-.085,0,0-.085-.127a.221.221,0,0,1,.2,0c-.127,0,0,.127,0,.183V6.22c.127.183,0-.155.229,0h0a.625.625,0,0,1,.229,0c0,.1-.085,0-.094.1s.237-.113.331,0H17.1a.3.3,0,0,0,.2.142h0l.183.1h-.042c.161-.212.288,0,.489-.085-.2.1,0,.085-.068.183s.119.085.093.113c.1,0,.144.1.279,0s.1,0,.068.1c.119,0,0,0,0-.1.2,0,.407.255.687.142a.759.759,0,0,0,.449-.408h0c.068,0,0,.155,0,.155a.6.6,0,0,0,.237-.4h.068c.068,0,0-.142,0-.325a.455.455,0,0,1,.051.2,2.05,2.05,0,0,0,0-.611A1.792,1.792,0,0,0,19.706,5.937ZM12.076,2.858Zm-.169,0a.1.1,0,0,1-.012.05.036.036,0,0,1-.03.02c-.042,0-.051,0-.094-.1ZM15.679,6.29a.135.135,0,0,1,0-.085h.093a.121.121,0,0,1-.093.043Zm3,.664h.034Zm.738-.407a1.162,1.162,0,0,0,.068-.2,2.359,2.359,0,0,1,0,.24L19.424,6.5Z",
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 44.933, 33.021)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137626",
    "data-name": "Path 137626",
    d: "M47.07,29.75v.029l.043-.014Z",
    transform: "translate(9.917 4.385)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137627",
    "data-name": "Path 137627",
    d: "M59,33.56Z",
    transform: "translate(14.835 5.955)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137628",
    "data-name": "Path 137628",
    d: "M48.58,32.09Z",
    transform: "translate(10.54 5.35)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137629",
    "data-name": "Path 137629",
    d: "M51.735,32.39H51.58C51.665,32.433,51.722,32.446,51.735,32.39Z",
    transform: "translate(11.776 5.473)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137630",
    "data-name": "Path 137630",
    d: "M45.129,31.664h0L45.1,31.65Z",
    transform: "translate(9.105 5.168)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137631",
    "data-name": "Path 137631",
    d: "M61.294,32.45H61.28l.029.056Z",
    transform: "translate(15.776 5.498)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137632",
    "data-name": "Path 137632",
    d: "M60.76,33.748a.663.663,0,0,0,.4-.2h0C61.1,33.635,60.83,33.663,60.76,33.748Z",
    transform: "translate(15.561 5.952)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137633",
    "data-name": "Path 137633",
    d: "M53.02,32.65l.113.07.07-.07Z",
    transform: "translate(12.37 5.58)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137634",
    "data-name": "Path 137634",
    d: "M59.914,39.289c.127,0,.3.1.325,0s-.156-.1-.353-.085-.127-.142-.1-.169-.142-.1-.226,0a.791.791,0,0,0,.407.282S59.927,39.275,59.914,39.289Z",
    transform: "translate(15.066 8.192)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137635",
    "data-name": "Path 137635",
    d: "M60.16,40.183a.354.354,0,0,0,0-.113v.1Z",
    transform: "translate(15.313 8.639)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137636",
    "data-name": "Path 137636",
    d: "M54.2,37.93a.212.212,0,0,1,0,.1S54.5,38.029,54.2,37.93Z",
    transform: "translate(12.857 7.756)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137637",
    "data-name": "Path 137637",
    d: "M60.13,40.18Z",
    transform: "translate(15.301 8.685)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137638",
    "data-name": "Path 137638",
    d: "M43.392,38.5a.3.3,0,0,0-.142-.085h0Z",
    transform: "translate(8.342 7.959)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137639",
    "data-name": "Path 137639",
    d: "M69.744,41.49c0-.255-.169-.611-.3-.611a.423.423,0,0,1,0,.142h.1c.1,0,0,.282,0,.3v-.123c-.155.156.085.523,0,.8a.846.846,0,0,0-.113-.183.48.48,0,0,0,.07-.2,1.06,1.06,0,0,0-.889-1.214h0a.746.746,0,0,0,0-.169.085.085,0,0,0,.085,0l.113-.085h-.183c0-.07-.07-.155-.24-.24h-.3v-.1h.226c-.113-.1-.212,0-.306,0a.169.169,0,0,0-.1-.1l-.282.113s.127-.1,0-.169.1.169-.113.183,0-.155-.24-.113,0,0,.085,0h-.438c-.085,0-.466,0-.424-.2a.917.917,0,0,1-.381,0c.255-.155-.466-.085-.381-.268-.2.142-.621,0-.932,0a.1.1,0,0,1,.085,0,1.315,1.315,0,0,1-.306-.142c0,.127-.306.127-.466.183-.183-.169.155-.142.113-.282,0,.113-.381,0-.325.169-.142-.113-.127-.07-.2-.2,0,.169-.142,0-.3.1s0-.169-.282-.156.113-.1.113-.1c-.255,0-.142.113-.2.183-.306,0-.127-.127-.226-.2s-.353.1-.494.07h0a2.836,2.836,0,0,0-.848,0h0a.282.282,0,0,1,0,.183h-.268c-.085-.142.169,0,.183-.113a2.936,2.936,0,0,1-.706,0c0-.127.424,0,.212-.113l.07.142c-.183-.226.155,0,0-.2s-.424,0-.776-.085c-.085,0,0,.1-.085.155-.523,0-.353-.354-.763-.255-.113,0-.169.212-.424.085l.113-.113c-.354-.07-.226.155-.593,0h-.127v-.12h-1.24s.1,0,0-.113a6.793,6.793,0,0,1-1.61-.325h-.212c-.183-.07,0,0-.113.085s-.142,0,0-.1a3.036,3.036,0,0,1-1.412-.127h.085c-.282-.085-.354.169-.611,0h0a8.251,8.251,0,0,1-1.765-.367c-.113.127-.611-.155-.677,0a2.683,2.683,0,0,0-.72-.325c-.127,0-.212.1-.381.1v-.127l-.24.085-.1-.142h-.085s.113.07.1.1a.777.777,0,0,1-.565-.226h-.325c-.311,0,0-.127-.325,0v.085a1.794,1.794,0,0,0-.677-.142v-.071a11.87,11.87,0,0,1-1.412-.169c.169,0,.113.183,0,.183V36.73c-.1,0,.142,0,0,.127s-.1-.155,0-.169H45.8V36.6c0-.085-.367-.169-.509,0h0a3.26,3.26,0,0,1-1.087-.113c0,.1-.169,0-.3.113a6.859,6.859,0,0,0-.932-.24c-.24,0-.085,0-.2.113s-.408-.306-.183-.306a5.762,5.762,0,0,0-1.059-.07s.113.07.07.1-.212,0-.183-.113h0c-.611,0-1.313-.466-1.807-.353h-.494c-.212,0,.142,0,0-.127a1.732,1.732,0,0,0-1.5.466.988.988,0,0,0-.509.946,2.2,2.2,0,0,0,.438,1.173h0c.155,0,.127.155.226.255s-.113-.155,0-.127a1.936,1.936,0,0,0,.889.3l.763.155,1.5.354c.367.07.255-.3.692,0l-.142.085c.763,0,1.511.24,2.241.226h-.1a.692.692,0,0,0,.579,0c.113,0,0,0,0,.1s.408,0,.48,0h-.085c-.085,0,.466.085.381,0,.268.085.537,0,.735.127s.466.127.537,0c0,.155.452.2.636.155,0,0,.142.07.07.127h.354c.339.24.749,0,.917.226h1.667c0,.156-.579,0-.579.1a6.61,6.61,0,0,1,1.3,0c.127,0-.085,0-.127.085.509,0,.961.155,1.412.142h.014c-.127-.127.381-.169.408-.226-.183.183.424.127.155.354,0,0,.127,0,.127-.085s.1,0,0,.1c.306,0,.212-.085.494,0a.111.111,0,0,0-.1.085.763.763,0,0,1,.537,0h0a6.5,6.5,0,0,1,1.158,0c-.155.142.155.085.155.212h.255l-.1-.085h.833l-.226-.085c.226,0,0-.169.282-.1a.441.441,0,0,1,.306.127h0a.579.579,0,0,1,.381,0v.183a3.222,3.222,0,0,0,.65,0c.155,0,0,.085,0,.1h.1c.1,0,.113,0,.085.113.3,0-.07-.183.268,0h0c.339.1.692,0,1,.142.07.156-.282,0-.2.113a6.528,6.528,0,0,1,1.412.1h-.072c.1-.183.325.142.564.085,0,0-.085.085-.07,0a5.211,5.211,0,0,0,1.121,0h0a3.191,3.191,0,0,1,.664.156c.2.056.183,0,.113-.1.579.367,1.186,0,1.7.339h.354c0-.085,0,0-.142-.127a.537.537,0,0,1,.306,0c-.212,0,0,.127,0,.183V42c.226.169.07-.155.381,0h0a1.725,1.725,0,0,1,.381,0c0,.1-.142,0-.155.1s.4-.127.551,0H65.2a.565.565,0,0,0,.325.142h0l.306.1h0c.255-.212.466,0,.8-.085-.325.1,0,.07-.1.183s.2.085.155.113.24.1.466,0c0,0,.155,0,.113.1.2,0,0,0,0-.1.311-.085.664.24,1.13.142a1.086,1.086,0,0,0,.72-.424h0c.1,0,0,.169,0,.169a.611.611,0,0,0,.4-.4h.113c.113,0,0-.142,0-.339a.509.509,0,0,1,.085.212,1.412,1.412,0,0,0,0-.611.673.673,0,0,0,.038.181ZM57.119,38.425Zm-.3,0h0a.209.209,0,0,1-.155-.1Zm6.27,3.389a.085.085,0,0,1,0-.085h.155A.2.2,0,0,1,63.093,41.815Zm4.971.664h.2a.268.268,0,0,1-.142,0Zm1.214-.424a1.538,1.538,0,0,0,.155-.24,1.536,1.536,0,0,1,0,.255.078.078,0,1,1-.155-.014Z",
    transform: "translate(5.814 6.796)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137640",
    "data-name": "Path 137640",
    d: "M46.05,36.69v.01l.043-.014Z",
    transform: "translate(9.497 7.245)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137641",
    "data-name": "Path 137641",
    d: "M57.87,40.48Z",
    transform: "translate(14.369 8.808)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137642",
    "data-name": "Path 137642",
    d: "M47.56,39Z",
    transform: "translate(10.119 8.198)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137643",
    "data-name": "Path 137643",
    d: "M50.692,39.32H50.55C50.62,39.363,50.677,39.376,50.692,39.32Z",
    transform: "translate(11.352 8.33)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137644",
    "data-name": "Path 137644",
    d: "M44.138,38.6Z",
    transform: "translate(8.697 8.033)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137645",
    "data-name": "Path 137645",
    d: "M60.17,39.37l.029.056-.014-.056Z",
    transform: "translate(15.318 8.351)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137646",
    "data-name": "Path 137646",
    d: "M59.66,40.668a.79.79,0,0,0,.408-.2h0C60.041,40.54,59.73,40.583,59.66,40.668Z",
    transform: "translate(15.107 8.804)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137647",
    "data-name": "Path 137647",
    d: "M52.083,39.66l.07-.07H51.97Z",
    transform: "translate(11.937 8.442)",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137648",
    "data-name": "Path 137648",
    d: "M35.311,38.539c-.1,0-.07-.113-.142-.212a3.26,3.26,0,0,0,.1-.692c0-.169-.085,0-.142-.127s.07-.268.142-.142a3.037,3.037,0,0,0-.142-.776v-.07h0c-.183-.407.085-1.059-.212-1.412h0c0-.113-.127-.212-.2-.325s.085.07.1,0c-.268-.325-.212-.593-.452-.848.113-.354-.48-.763-.537-1.121h0c-.1,0,0-.113-.07-.169s0,.1,0,.085c-.509-.537-.917-1.214-1.412-1.751-.2-.2-.325.142-.494-.183H32c-.509-.24-.889-.692-1.412-.889h.1c.1,0-.354-.226-.4-.169s0,0,0-.127-.306,0-.325-.142,0,0,.07,0-.306-.169-.282,0c-.169-.127-.367-.142-.494-.255s-.3-.2-.381-.07c.07-.142-.282-.255-.424-.226s-.1-.085,0-.142-.268,0-.268,0c-.2-.268-.565,0-.65-.3a7.177,7.177,0,0,1-1.257-.07c0-.155.438,0,.452-.113a4.532,4.532,0,0,1-.961,0c-.1,0,0-.07.085-.085a3.5,3.5,0,0,0-1.019,0h-.07c.085.113-.268.2-.3.255.127-.2-.306-.085-.113-.325,0,0-.1,0-.1.085s-.085,0,0-.1c-.226,0-.155.113-.367.1l.07-.085a.509.509,0,0,1-.4.1h0c-.306,0-.509.212-.862.2.07-.169-.113,0-.169-.142l-.169.07h.085c-.155,0-.255.155-.4.169l.085-.1-.268.127h.169c-.127.113,0,.155-.127.183h-.255a.339.339,0,0,1-.226.155v-.169c0-.029-.325.183-.354.339s0-.113,0-.113v.1h-.113c-.014,0,.142.127-.127.169h0c-.255.1-.424.282-.65.381s.169-.142,0-.2c-.3.212-.523.537-.791.735h0c.085.155-.255.085-.306.268v-.085a1.906,1.906,0,0,0-.48.677h0c-.127.07-.24.268-.339.381s0,.127,0,.127c-.48.24-.3.8-.664,1.059v-.085l-.1.325h.155a.354.354,0,0,1,0,.24c0-.169-.127,0-.2,0a.128.128,0,0,1,.07,0c-.2.113.142.085,0,.268h0v.268c0,.085,0-.1-.07-.127s.085.306,0,.4a1.074,1.074,0,0,0,0-.212.325.325,0,0,0-.3-.056h0l-.113.2h0c.183.24,0,.339,0,.611-.085-.255,0,0-.169-.113s-.1.127-.127.1-.113.155,0,.339,0,.127-.113.085.07,0,.113,0-.24.494-.085.848a2.915,2.915,0,0,0,.3.523h0c0,.07-.127,0-.127,0a.438.438,0,0,0,.142.367l-.07.085c-.07.085.142,0,.2.142a.407.407,0,0,1-.183,0,1.863,1.863,0,0,0,.354.226c0,.07-.127,0-.183,0a.861.861,0,0,0,.3.155.127.127,0,0,1-.1-.169h.085c0-.212-.282-.24-.367-.424h.155a1.624,1.624,0,0,0,1.074.735h0a.381.381,0,0,0,0,.169.084.084,0,0,0-.07,0l-.07.113h.127a.268.268,0,0,0,.169.226l.2-.07v.1h-.169c.085.085.155,0,.226,0s0,.085.07.1l.212-.127c0,.07-.1.113,0,.169s0-.155.1-.183,0,.155.155.1,0,0,0,.085.255,0,.306,0,.339,0,.3.183a.452.452,0,0,1,.282-.085c-.2.155.325,0,.255.255.155-.156.452,0,.677,0h0l.212.127c.07.043.226-.127.339-.2.127.155-.113.142-.085.268,0-.1.268,0,.24-.169s.085,0,.127.183c0-.169.1,0,.212-.1s0,.169.2.142-.085.1-.085.1.1-.113.155-.183.085.113.142.2.268-.113.367-.1h.611a.381.381,0,0,1,0-.183h.183c0,.127-.127,0-.142.113s.381-.085.509,0-.306,0-.155.127l-.183-.085c.113.212-.127,0,0,.2s.3,0,.551,0,0-.1,0-.155c.4,0,.24.339.537.226s.142-.212.325-.1l-.1.127c.255,0,.183-.169.424,0h.1V39h.875s-.085,0,0,.113a3.389,3.389,0,0,1,1.13.268h.155l.1-.085c.1-.085.1.07,0,.1a1.766,1.766,0,0,1,.975.07h0c.2.07.268-.169.438,0h0a4.845,4.845,0,0,1,1.243.306c.1-.142.424.142.494,0a1.752,1.752,0,0,0,.494.282c.1,0,.169-.1.282-.1v.1l.183-.085v.142h.113a.068.068,0,0,1-.07-.085.452.452,0,0,1,.408.2h.268c.24-.07,0,.127.24,0v-.085a.833.833,0,0,0,.48.127h0a2.387,2.387,0,0,0,1.243,0c-.212,0-.183-.113,0-.169h.1c.07-.1-.155,0,0-.127s.183,0,.1.127a1.215,1.215,0,0,0,.183-.2v.113c0,.113.4-.353.3-.523h0a3.158,3.158,0,0,0,.1-.946Zm-17.285-6.5v-.029ZM16.98,35.178Zm0,.255v.155a.2.2,0,0,1-.085-.1Zm0,1.019a.093.093,0,0,1,.183-.029.424.424,0,0,0,.085.155ZM26.386,38.852Zm.2,0h0c0,.07,0,0,.1.085Z",
    transform: "translate(-2.643 3.717)",
    fill: "#fc6d86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137649",
    "data-name": "Path 137649",
    d: "M22.7,20.767s.1,0,.085.085h.119c-.226.1,0,.325-.169.424l.07.268h0s.2,0,.155.155-.07,0-.113,0,0,.142,0,.24h0c0,.085.127.127.142.226h0a.466.466,0,0,1,.268.212h-.149c-.142,0,.142-.07.183,0a.354.354,0,0,1-.142.155h0c-.1.085,0,.1,0,.142h0c0,.113.183,0,.226.183h0c.155,0,0,.085.085.113l-.127.07a1.229,1.229,0,0,1,.255.155.564.564,0,0,1-.282-.1s.07.142.142.142h0a.24.24,0,0,1,.24.127c-.255.113,0,.24-.1.4.169.1.127.325.255.48.127-.169,0,0,.212-.085h0v.183c0,.07-.07,0-.1,0s0,.085,0,.169.113,0,.127,0v-.127c.169,0-.07.212.1.255h-.318c.07,0,.183.212.354.142s0,.085-.07.07.4.142.424.325h.169c.085.169.3.07.424.113a.268.268,0,0,0,0,.306h0c.169.127.367.085.565.1s.325.226.48.381,0-.113.085-.127.142-.07.1,0h0c0,.155.113.142.183.155v-.183c.155.306.494,0,.593.2a.176.176,0,0,0,.155-.1v.1a.735.735,0,0,0,.381,0v.07c.113,0,0-.306.127-.325v.127c.142,0,.381,0,.438-.2a.085.085,0,0,1,0,.085s.3,0,.169-.226c.07.113.142,0,.169-.169v-.169c0-.085.07,0,0,0s0-.113.085-.127v.07c.07,0,0-.07,0-.156s.113-.085.183,0,0-.127,0-.142h0s0-.212.183-.212h0l-.127.142a.212.212,0,0,1,.185.131v-.325h.07c.07,0,.085,0,.113-.1s0-.085-.142-.085h0v-.029l.2.24h.354c.085,0,.1-.3,0-.438s0,0,.1,0,0,0,0,.07,0-.212-.07-.268.1.085.113,0h0c.268-.212-.24-.438,0-.664h0c.156-.306-.127-.611,0-.932,0-.085,0-.085-.142-.113H29.66c-.113-.085.2-.282,0-.381h-.07s-.1-.155,0-.183-.085,0,0,0h0l-.142-.085c0-.113.2-.07.142-.226a.311.311,0,0,0-.24,0v.1h0a3.108,3.108,0,0,0-.24-.354h0l-.3-.367h0s-.07,0,0-.1h-.07s.085-.07.085,0-.183,0-.127-.155-.113,0-.183,0h0l.113-.169h-.183c-.1,0-.169-.085-.07-.226s0,.085-.085.085c.113-.155-.085,0,0-.142s.085,0,.1-.085-.085-.113-.142-.113a.085.085,0,0,1-.07,0h.07s-.07,0-.1.1-.085-.07-.155-.085-.1-.155-.155-.24h0c-.085.1-.142,0-.212,0a.183.183,0,0,1,.113-.1h0a.169.169,0,0,1-.113,0h.066a.326.326,0,0,1-.268-.085,1.411,1.411,0,0,1-.1.212h-.014c-.085,0,0,0,0-.113h0a.254.254,0,0,1,0-.142v-.056c0-.043-.07,0-.113.07s0,0,0-.1-.2,0-.183.07h0c-.155,0-.255-.142-.4-.142h-.255c-.07,0,0-.07,0-.113s-.07,0-.155,0h.07c.07,0-.085-.1-.183,0s0-.113-.085-.1v.07a.156.156,0,0,1-.113,0V19.1c-.155-.169-.306.226-.438,0,0,0,.1,0,0,.155s-.169-.183-.183-.183-.1.183-.212.142,0,.142,0,.2-.113-.155,0-.2h0v-.085h0s-.155,0-.142-.085,0,0,0,.085-.155,0-.268,0h0l-.085-.07s0-.155-.113-.085,0-.1,0-.142-.183,0-.255,0h0a.127.127,0,0,1-.085,0l.07.07h-.07c-.07,0,.07.127,0,.212s-.085.1-.142,0,0-.085,0-.155,0,0-.085,0h0c-.155,0,0,.142-.1.2s-.085-.085-.1,0,.085,0,.07.142,0,.07-.1.085h0v.056c0-.07-.183,0-.2.1s-.085-.085-.127-.085a.171.171,0,0,0-.183.142c-.043.142.07,0,.085.127a.551.551,0,0,1,.085-.155v.155s0-.113.07-.113,0,0,0,.1,0,.142-.155.142l-.085-.212c-.155,0-.07.24-.2.354h0v.156a.183.183,0,0,0-.142,0v.183H22.7c-.085.127.142.212.085.306s-.127,0-.155-.1,0,0,0,.085S22.789,20.735,22.7,20.767ZM29.537,24.905Zm-.791-4.237h0s.056.043.056.056Z",
    transform: "translate(-0.163 -0.119)",
    fill: "#fc6d86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137650",
    "data-name": "Path 137650",
    d: "M72.928,19.571c-.1.593-.2,1.243-.3,1.92-.085.268,0,0,0-.07-.127.9-.24,1.963,0,1.412,0-.917.156-1.121.212-2.1.113-.763.255-1.324.282-1.2a7.952,7.952,0,0,0,.142-1.638C73.213,18.4,73.027,18.964,72.928,19.571Z",
    transform: "translate(20.397 -0.505)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137651",
    "data-name": "Path 137651",
    d: "M71,19.47a6.22,6.22,0,0,0,0,.749Z",
    transform: "translate(19.779 0.147)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137652",
    "data-name": "Path 137652",
    d: "M61.17,12.2Z",
    transform: "translate(15.73 -2.851)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137653",
    "data-name": "Path 137653",
    d: "M71.05,19.37l.085-.65Z",
    transform: "translate(19.803 -0.163)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137654",
    "data-name": "Path 137654",
    d: "M32.09,7.89a4.773,4.773,0,0,1,.611.183C32.5,8.045,34.491,8.244,32.09,7.89Z",
    transform: "translate(3.741 -4.628)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137655",
    "data-name": "Path 137655",
    d: "M71,19.59a1.412,1.412,0,0,1,0-.408Z",
    transform: "translate(19.778 0.027)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137656",
    "data-name": "Path 137656",
    d: "M40.1,49.25l2.146.339Z",
    transform: "translate(7.043 12.424)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137657",
    "data-name": "Path 137657",
    d: "M46.13,50.15c.381.1.776.169,1.2.255h.255Z",
    transform: "translate(9.529 12.795)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137658",
    "data-name": "Path 137658",
    d: "M71.275,27.869l-.085-.1Z",
    transform: "translate(19.861 3.568)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137659",
    "data-name": "Path 137659",
    d: "M97.261,30.05a.975.975,0,0,0,.848.636.988.988,0,0,1-.763-.763.807.807,0,0,1,0-.183.819.819,0,0,0,1.624.212c.325-1.412.579-2.712.815-4.081l.339-2.048a5.832,5.832,0,0,0-.155-2.514l-.1-.212c.1.07.212.226.268.24s0,.3.127.593a3.5,3.5,0,0,1,.183.551,5.93,5.93,0,0,0-.255-1.229h0a3.954,3.954,0,0,0-.862-2.118,6.5,6.5,0,0,0-1.834-1.511l-.636-.407a6.4,6.4,0,0,1,1.652,1.074,4.76,4.76,0,0,0-2.265-1.28,4.068,4.068,0,0,0-.932-.306l-2.175-.169c-.24-.1.988,0-.452-.226-1-.085.946.282-.72.085a8.12,8.12,0,0,0-1.92-.325c-.169-.07.1,0,.579,0-1.087-.113-2.825-.407-3.464-.407-1.074-.255-3.667-.523-3.545-.664-.354,0-1.936-.169-2.937-.306,1.85.085-3.743-.565-3.235-.692-1.412,0-4.89-.65-7.3-.917a3.347,3.347,0,0,1,.611,0c-1.412-.212-1.723-.325-2.585-.48a33.894,33.894,0,0,1-3.446-.268c-1.624-.367,1.031,0,.537-.212,0,.127-2.9-.306-2.343-.142a10.987,10.987,0,0,1-1.723-.407,12.612,12.612,0,0,1-2.241-.2,15.154,15.154,0,0,0-2.4-.466c-.946-.2.848,0,.848,0-2.048-.306-.975,0-1.412,0-2.445-.325-1.121-.255-1.936-.452-1.528-.2-2.726-.255-3.856-.424-.085,0-.3-.07,0,0-1.624-.142-4.788-.72-6.68-.862l-.354-.155c.3.113.339.183.268.212a16.042,16.042,0,0,1-2.048-.212,5.085,5.085,0,0,0,.876,0L41.3,8.905c-.848-.255,1.313.155,1.324.07-1.879-.24-4.081-.466-5.508-.72-.282-.169,3.362.466,1.412,0l2.217.381c-1.667-.452,1.412.212-.183-.226l-6.143-.8c-.664,0,.2.127-.466.1-4.167-.509-3.22-.791-6.285-1.087a15.535,15.535,0,0,1-3.291-.339h.762c-2.825-.438-1.638,0-4.618-.565.537,0,2.241.268,1.822.2a7.6,7.6,0,0,0-1.6-.226,10.579,10.579,0,0,0-1.324,0l-.344-.107A6.129,6.129,0,0,0,14.84,8.127a5.649,5.649,0,0,0-1.019,2.4c-.2.848-.255,1.681-.4,2.514,0-.183,0-.763-.113,0-.565,4.237-1.412,8.982-2.037,13.04l-.127,1.568c0,.354-.142.65-.1.268-.282,1.568,0,.085,0,.848s-.24,1.186-.183.611c-.325,2.825-1,7.98-1.554,10.917v-.579c-.369,2.254-.165,2.6-.573,4.7v-.408c-.381,2.5-.776,5.112-1.144,7.584l-.48,3.545a18.9,18.9,0,0,0-.4,3.291,7.824,7.824,0,0,0,.975,2.825,4.364,4.364,0,0,0,1.88,1.806,4.914,4.914,0,0,0,1.412.763A9.422,9.422,0,0,0,12,64.126c.65.142,1.412.282,3.446.621,1.059.169,1.61.1,2.924.282v.113l1.807.155,1.059.183,1.243.155a3.4,3.4,0,0,1-.961-.226c.975.127,2.146.306,3.079.494a15.535,15.535,0,0,1,1.667.354l4.589.593a6.516,6.516,0,0,1-1.044-.084c1.75.2.14.141,2.23.353h.227c1.121.226,3.644.611,5.536.862h-.367l10.96,1.61c-1.412-.24-1.019-.325.1-.169l.424.183c.735,0-1.158-.212.339-.085s.932.268.113.183l1.737.226H50.69c.72,0,2.966.565,4.011.593h.1l8.643,1.243a16.95,16.95,0,0,1,2.217.169c2.274.367,4.788.833,7.539,1.229,1.936.24.579,0,1.412.07.127.113,2.825.509,1.412.367,3.3.48,4.237.611,8.389,1.158-.438-.1-.946-.2-.677-.183a7.06,7.06,0,0,1,1.6.325h-.2l1.85.226a6.044,6.044,0,0,0,2.048-.169,6.27,6.27,0,0,0,3.444-2.222A7.273,7.273,0,0,0,93.89,69.05c.183-1.173.339-2.26.424-3.192v.212l.367-3.883c.282-1.78-.1,1.074.155-.226.48-4.237,1-6.581,1.412-10.041.339-1.3.677-3.657,1.031-6.143.183-1.229.367-2.5.537-3.686s.4-2.274.438-3.248V38a1.412,1.412,0,0,0-.339-.975,1.528,1.528,0,0,1,.282.565.611.611,0,0,1,0,.212,2.165,2.165,0,0,1,0-.255,1.186,1.186,0,0,0-1.893-.523,2.019,2.019,0,0,0-.466.8,6.664,6.664,0,0,0-.255.749,26.465,26.465,0,0,0-.551,3.037c-.354,2.019-.749,4.11-1.059,6.087-.65,4.068-1.313,8.163-1.949,12.188-.452,2.937,0,1.708-.636,5.408V64.218c-.2,1.5-.408,2.994-.611,4.5a5.056,5.056,0,0,1-.564,2.006,3.319,3.319,0,0,1-3.531,1.412l-2.241-.325-4.435-.621a8.063,8.063,0,0,1,.946.085c-.611-.142-1.751-.306-2.739-.438l-1.286-.155h-.551c-.9-.142-.212-.1-.763-.212-1.214-.24-3.107-.354-3.743-.537h.3a18.725,18.725,0,0,0-2.669-.212c-2.175-.367-4.237-.579-5.918-.889-1.158,0-3.729-.611-4.11-.509a33.9,33.9,0,0,0-5.211-.833c.48,0-1.186-.226-.636-.212A11.454,11.454,0,0,0,50.9,66.9c-2.825-.636-5.847-.72-7.457-1.214L30.2,63.892c.183-.142,4.661.677,4.5.48-4-.523-6.327-.735-10.281-1.412-1.031-.169.593,0,.946,0-4.011-.537-7.725-1.173-11.3-1.624l.763.07a9.065,9.065,0,0,0-1.554-.183l.677.085c.551.142-.142.1-1,0a5.4,5.4,0,0,1-1.834-.438c.579.183-.226-.169-.72-.763s-.706-1.186-.169-.509c-.268-.325-.466-.815-.48-.706-.169-.621-.155-.815,0-.212a4.392,4.392,0,0,1-.113-1.893,7.938,7.938,0,0,1,.221-1.847,4.152,4.152,0,0,1,0,.706c.113-1.158.212-2.317.523-4.237v.48c.48-3.3.664-5.649,1.257-9.25,0,1.087.24-1.229.4-1.412l.255-1.949-.183.763c.255-1.7.4-3.22.65-4.675l-.127,1.271.452-3.192-.306,1.949c.183-1.723-.2.169.183-2.09,0,.452.255-1.708.466-2.585h0c.085-.848.169-1.723.381-2.966.1-.325.113.282.169,0,0-.848.565-4,.611-5.07,0,.367,0,.4.07.282v-.72c.155-.776.183-.889.212-.763.381-2.373-.268.735.212-2.076a3.983,3.983,0,0,1,0,.579c.407-2.825.8-5.451,1.186-8.064.255-.749-.306,2.274,0,1.412a9.984,9.984,0,0,1,.2-1.412l.085-.72.169-.65a3.517,3.517,0,0,1,1.737-2.006,4.237,4.237,0,0,1,2.714-.224l2.825.407L23.327,8.6c.523-.1,2.683.509,4.533.692h-.48c2.471.4,5.085.706,8.855,1.214h-.466l5.239.917c.48,0,1.412.169.833,0,4.844,1,9.32,1.243,13.614,2.118-.509-.085-1.229-.142-.815-.085l3.686.509a7.16,7.16,0,0,0-1.243-.3c.48,0,1.528.142,2.429.268-1.652-.183,0,.142.706.282H60.3c1.893.424.339-.113,2.954.367h-.142c.988.127,1.906.2,2.966.367.424.155-1.059-.113-1.144,0,1.5.212,2.966.268,4.237.551l-2.189-.268c1.412.325,1.624.325,2.726.509h-.029l2.514.424-.636-.127c1.893,0,3.8.523,6.341.735-2.471-.212-.424,0-.621.113a6.826,6.826,0,0,1,1.324.282c1.186.1,1.963.367,3.657.494,0,0,1.271.2.988.24,1.554.2-.353-.113-.226-.142,2.4.24,5.649.975,9.024,1.324,1.412.2,2.373.255,3.192.381a3.418,3.418,0,0,1,1.822.975h0a3.308,3.308,0,0,1,.367.48,2.231,2.231,0,0,1,.282.509,2.547,2.547,0,0,1-.169-.24,4.672,4.672,0,0,0-.438-.565,4,4,0,0,1,.791,1.807,7.683,7.683,0,0,1-.085,1.949c0-.282,0,0-.155.424-.142,1.144,0,.776-.183,2.274a9.456,9.456,0,0,1,.029-1.144c-.085,1.412-.226,2.641-.24,4.11,0,.226-.113,0-.085-.4s0-.735,0-.988a12.2,12.2,0,0,0,0,1.412,1.059,1.059,0,0,0,1.144.815.932.932,0,0,1-.677-.2.8.8,0,0,1-.381-.643Zm-83.663-18-.127.988h0C13.525,12.63,13.569,12.274,13.6,12.048Zm-.466,3.26c0-.142.07,0,0,.424a11.944,11.944,0,0,0-.268,1.313c.07-.478.169-1.1.268-1.735Zm36.973-2.7s-.085,0,0-.085l1.412.2a6.073,6.073,0,0,1-1.412-.113ZM90.51,18.655l-.537-.169,1.61.24ZM97.9,23.838c0-.24.113-.438.142-.367h0l-.255,1.78c.043-.438.07-.917.113-1.412Zm-.2,1.2v.65c-.169,1.286-.3,2.585-.381,3.883V28.389c.183-1.121.183-2.358.381-3.347Z",
    transform: "translate(-6.718 -5.58)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137660",
    "data-name": "Path 137660",
    d: "M23.174,48.9Z",
    transform: "translate(-0.11 12.279)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137661",
    "data-name": "Path 137661",
    d: "M53.09,51.19Z",
    transform: "translate(12.399 13.224)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137662",
    "data-name": "Path 137662",
    d: "M71.96,23.31l-.24.127Z",
    transform: "translate(20.08 1.73)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137663",
    "data-name": "Path 137663",
    d: "M72.045,23.2a1.6,1.6,0,0,1-.155.155Z",
    transform: "translate(20.149 1.684)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137664",
    "data-name": "Path 137664",
    d: "M72.05,23.13v0Z",
    transform: "translate(20.215 1.655)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137665",
    "data-name": "Path 137665",
    d: "M71.562,23.43Z",
    transform: "translate(20.012 1.779)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137666",
    "data-name": "Path 137666",
    d: "M72.05,23.188a.9.9,0,0,0,.113-.2A.664.664,0,0,1,72.05,23.188Z",
    transform: "translate(20.215 1.597)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137667",
    "data-name": "Path 137667",
    d: "M72.326,22.17l-.226.975c.1-.537.155-.3,0,.169a1.412,1.412,0,0,0,.113-.452,3.019,3.019,0,0,0,.113-.692Z",
    transform: "translate(20.236 1.26)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137668",
    "data-name": "Path 137668",
    d: "M72.13,23Z",
    transform: "translate(20.248 1.602)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137669",
    "data-name": "Path 137669",
    d: "M71.73,23.42Z",
    transform: "translate(20.013 1.774)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137670",
    "data-name": "Path 137670",
    d: "M15.144,47.726V47.7l-.354-.029Z",
    transform: "translate(-3.391 11.773)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137671",
    "data-name": "Path 137671",
    d: "M44.61,11.71Z",
    transform: "translate(8.902 -3.053)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137672",
    "data-name": "Path 137672",
    d: "M51.38,12.74l1.342.24Z",
    transform: "translate(11.693 -2.628)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137673",
    "data-name": "Path 137673",
    d: "M56.57,13.55Z",
    transform: "translate(13.833 -2.294)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137674",
    "data-name": "Path 137674",
    d: "M12.44,45.2h.282C13.386,45.327,12.934,45.27,12.44,45.2Z",
    transform: "translate(-4.359 10.754)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137675",
    "data-name": "Path 137675",
    d: "M11.477,23.38l-.127,1.13A4.138,4.138,0,0,0,11.477,23.38Z",
    transform: "translate(-4.81 1.758)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137676",
    "data-name": "Path 137676",
    d: "M39.93,49.22Z",
    transform: "translate(6.974 12.412)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137677",
    "data-name": "Path 137677",
    d: "M11.42,24.18c-.085.509-.183,1.1-.24,1.61C11.293,25.182,11.363,24.66,11.42,24.18Z",
    transform: "translate(-4.879 2.088)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137678",
    "data-name": "Path 137678",
    d: "M72.262,22.87h0a.735.735,0,0,1,0,.155.548.548,0,0,1,0-.155Z",
    transform: "translate(20.3 1.548)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137679",
    "data-name": "Path 137679",
    d: "M72.275,23a1.413,1.413,0,0,1-.155.325A1.413,1.413,0,0,0,72.275,23Z",
    transform: "translate(20.244 1.602)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137680",
    "data-name": "Path 137680",
    d: "M72.3,22.56Z",
    transform: "translate(20.319 1.42)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137681",
    "data-name": "Path 137681",
    d: "M72.442,22l-.142.815A5.877,5.877,0,0,0,72.442,22Z",
    transform: "translate(20.319 1.19)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137682",
    "data-name": "Path 137682",
    d: "M71.564,17.826a5.3,5.3,0,0,0-.537-1.13,2.711,2.711,0,0,0-1.019-.946,3.7,3.7,0,0,1,1.5,2.006Z",
    transform: "translate(19.374 -1.387)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137683",
    "data-name": "Path 137683",
    d: "M13.3,12.154l-.014-.494L13.1,13.143Z",
    transform: "translate(-4.088 -3.073)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137684",
    "data-name": "Path 137684",
    d: "M23.88,21.06a.339.339,0,0,0,.268,0h-.127s-.1.1,0,.142S23.909,21.06,23.88,21.06Z",
    transform: "translate(0.357 0.802)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137685",
    "data-name": "Path 137685",
    d: "M24.11,21.31Z",
    transform: "translate(0.451 0.905)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137686",
    "data-name": "Path 137686",
    d: "M24.675,19.57H24.59C24.66,19.57,24.633,19.64,24.675,19.57Z",
    transform: "translate(0.649 0.187)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137687",
    "data-name": "Path 137687",
    d: "M24.11,21.32Z",
    transform: "translate(0.451 0.909)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137688",
    "data-name": "Path 137688",
    d: "M27.77,22.24h.085Z",
    transform: "translate(1.96 1.289)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137689",
    "data-name": "Path 137689",
    d: "M24,21.15Z",
    transform: "translate(0.406 0.84)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137690",
    "data-name": "Path 137690",
    d: "M24.52,19.89Z",
    transform: "translate(0.62 0.32)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137691",
    "data-name": "Path 137691",
    d: "M23.94,21.15h.014Z",
    transform: "translate(0.381 0.84)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137692",
    "data-name": "Path 137692",
    d: "M26.7,18.919l.014-.029Z",
    transform: "translate(1.519 -0.092)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137693",
    "data-name": "Path 137693",
    d: "M24.3,21.93Z",
    transform: "translate(0.53 1.161)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137694",
    "data-name": "Path 137694",
    d: "M26,23.177Z",
    transform: "translate(1.231 1.665)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137695",
    "data-name": "Path 137695",
    d: "M27.63,22.39Z",
    transform: "translate(1.902 1.351)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137696",
    "data-name": "Path 137696",
    d: "M24.094,21.14Z",
    transform: "translate(0.439 0.835)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137697",
    "data-name": "Path 137697",
    d: "M24.14,21.5V21.39h0S24.068,21.489,24.14,21.5Z",
    transform: "translate(0.451 0.938)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137698",
    "data-name": "Path 137698",
    d: "M25.616,23.05l-.015-.07-.043.085Z",
    transform: "translate(1.049 1.594)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137699",
    "data-name": "Path 137699",
    d: "M30.392,21.33c-.113-.07,0-.085-.2-.155s0-.085.085-.07,0-.085,0-.113a.188.188,0,0,0,0,.24.1.1,0,0,1-.085,0A.268.268,0,0,0,30.392,21.33Z",
    transform: "translate(2.925 0.772)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137700",
    "data-name": "Path 137700",
    d: "M30.26,21.66Z",
    transform: "translate(2.987 1.05)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137701",
    "data-name": "Path 137701",
    d: "M29.43,18.22V18.3S29.543,18.333,29.43,18.22Z",
    transform: "translate(2.645 -0.369)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137702",
    "data-name": "Path 137702",
    d: "M30.25,21.682Z",
    transform: "translate(2.982 1.056)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137703",
    "data-name": "Path 137703",
    d: "M23,23.713a.3.3,0,0,0,0-.113h0Z",
    transform: "translate(-0.006 1.849)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137704",
    "data-name": "Path 137704",
    d: "M30.23,21.33Z",
    transform: "translate(2.975 0.913)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137705",
    "data-name": "Path 137705",
    d: "M23.045,19.4h0c0,.325-.593.537-.523.862h0v.282c0,.113,0-.085-.127,0,0,.325-.155.438-.113.692-.306.142-.113.65-.282.889h.07v.127c0,.043,0-.07.085,0a14.022,14.022,0,0,0,0,1.723c0,.2.354,0,.268.306H22.3c.255.354.282.8.593,1.121H22.8c-.014,0,.156.282.212.24s0,0,0,.1.2.127.169.212h0s.142.212.2.113c0,.155.2.212.24.339s.127.226.268.142c-.127.1.085.3.212.3s0,.1,0,.113.183.127.226,0c0,.282.407.127.354.4l.862.325c-.085.142-.282-.142-.354,0,.268.1.48,0,.706.183s0,0-.1,0a3.206,3.206,0,0,0,.763.2h.127c0-.127.24-.169.268-.226-.142.183.212.113,0,.339a.127.127,0,0,0,.085-.085v.1c.183,0,.142-.085.282,0s0,0,0,.07a.354.354,0,0,1,.3,0h0c.226,0,.4-.142.621,0-.07.142.085,0,.1.183h.142c.113,0,.212-.113.306,0h0c.113-.07,0-.155.142-.127s.113,0,.169,0h0s.1-.1.183-.085,0,.155,0,.183.268-.07.306-.212a.3.3,0,0,0,0,.113v-.1a.074.074,0,0,1,.07.085c0,.085-.085-.142.113-.127h0c.2,0,.339-.142.509-.169s-.127.085,0,.169.438-.325.664-.407h0c0-.183.212,0,.282-.142s0,.113,0,.1a1.638,1.638,0,0,0,.438-.408h0c.1,0,.212-.127.306-.183s0-.085,0-.113c.424,0,.367-.509.72-.565v.07l.142-.212h-.142a.183.183,0,0,1,0-.169c0,.113.1.085.156.07h0c.2,0-.113-.113.07-.2h0v-.07c0,.043,0-.255.1-.282a.494.494,0,0,1,0,.155c.156,0,.127,0,.183-.1h0l.127-.113h0c-.155-.24.1-.24,0-.466,0,.212,0,0,.155.127s.1-.07.113,0,.127-.1,0-.255,0,0,.113,0h-.1c-.1,0,.268-.3.2-.565a2.277,2.277,0,0,1-.113-.452h0l.1.07a.282.282,0,0,0,.07-.255h.085c.085,0-.113-.07,0-.155l.127.1a1.651,1.651,0,0,0-.085-.282c-.014-.085,0,0,.113.1a1.323,1.323,0,0,0,0-.226c0,.085,0,.113-.085.113v-.07c-.212,0,0,.268,0,.4h-.127a5.4,5.4,0,0,0,.1-.961h.282a.2.2,0,0,0,.183-.142l-.1-.155h.07v.127c.07-.085,0-.127,0-.169a.142.142,0,0,0,.085-.07l-.169-.142H34.5c.029,0-.127.085-.2,0s.127-.07,0-.142h.085c0-.07,0-.2-.142-.226s-.07-.24.085-.268a.353.353,0,0,1-.169-.155c.212.07,0-.255.142-.282-.183,0-.183-.3-.325-.424h0v-.212c0-.07-.226-.07-.339-.113s.169,0,.282-.085c-.1,0-.2-.142-.255,0s0-.085.085-.183c-.169.07-.07,0-.2-.07s.127-.113,0-.2.127,0,.127,0h-.2c-.07,0,0-.127,0-.212s-.226-.07-.268-.142h0s-.2-.268-.381-.282a.537.537,0,0,1-.127.127s-.142,0-.085-.1,0,0,.085,0H32.62c0-.127.1,0,.169,0s-.3-.1-.339-.2.183.142.183,0v.129c0-.212,0,.085.127-.142s-.2-.127-.325-.3,0,.085-.127.1c-.3-.1,0-.367-.24-.4s-.2.127-.268,0l.127-.085c-.155-.127-.212.085-.325-.1s.155,0,.142,0h-.2v-.111a6.639,6.639,0,0,0-.636-.24s.085,0,0-.1a3.149,3.149,0,0,1-.8-.424h-.127v-.07c0-.07,0,0-.1.085s0-.07,0-.1a1.13,1.13,0,0,1-.746-.078h0c-.156,0-.212.183-.339.07h0a4.942,4.942,0,0,1-.975-.127c0,.155-.353,0-.353.169-.2-.07-.155-.113-.438-.142s-.085.155-.169.2v-.113l-.085.142-.1-.1h0a.325.325,0,0,1-.354,0l-.268.2.07-.113c.07-.113-.07-.1-.183,0s0,0,0,.085-.255,0-.367.127V17.6A3.657,3.657,0,0,0,24.9,18a.1.1,0,0,1,.1.155l-.1-.085c0,.085.1,0,0,.113s-.127-.07-.1-.127h0c0-.1-.226,0-.212.183h0a2.556,2.556,0,0,0-.438.438c.07.07,0,.113,0,.212a1.78,1.78,0,0,0-.424.325v.169c0,.085-.183.1-.169,0a1.511,1.511,0,0,0-.268.523h.1C23.412,19.918,23.074,19.424,23.045,19.4Zm1.78,3.05h.113a.268.268,0,0,0,.2-.07l-.1-.085h.085v.07c.07,0,0-.07,0-.1H25.2l-.155-.1h.142a.166.166,0,0,0-.085-.142c-.085-.043,0-.127.155-.1a.183.183,0,0,1-.1-.127c.155.113,0-.127.226,0-.155-.085,0-.169-.07-.282h.127c.043,0-.127-.142-.183-.226.155,0,.127.113.255.142-.1,0,0-.127-.142-.156a.306.306,0,0,1,.155,0c-.142-.085,0,0-.085-.127s.155,0,.142,0a.07.07,0,0,1,.07,0,.438.438,0,0,0-.127-.1c0-.1.1,0,.169,0s-.085-.169,0-.2h0c0-.1.085-.127,0-.268h0l-.142-.1h0c.113,0,0,.07.07.127s0-.2,0-.226,0,.127.07.142h-.085c.183.085,0,0,.142.127s0-.127.127-.169,0-.07-.1-.127.282.142.255,0-.113-.2,0-.183v.127c.085,0,0-.2,0-.183v.056c.085-.07.142-.212.24-.282a.1.1,0,0,0,0,.1.48.48,0,0,1,.8-.255v-.113h0V19.58c0,.085.24-.255.367-.155h0c.07,0,0-.212.142-.142h0c.183,0,.381-.07.523.1,0-.155.155.07.2-.127.085.113,0,.142.169.24s.085-.113.142-.127v.1l.085-.085v.127h0a.085.085,0,0,1,0-.085.133.133,0,0,1,.113.169l.24.127h-.07c-.07,0,0,.113.07,0h0a.155.155,0,0,0,.155.113v.07a1.026,1.026,0,0,1,.354.142c.113.056,0-.155.1-.142v.1l.085-.1c.085-.1,0,.127-.085.142h.078l-.07.07c-.07.07,0,.155.113.085h0c.1.07.155.085.24.155s.1,0,.169-.07,0,.212.113.268.07,0,.142,0,0,.127-.085.127a.889.889,0,0,0,.24.183h0v.085h0c.212.085,0,.452.155.494h0l.142.085c0,.07-.085,0-.127,0,.212.085,0,.226.183.306-.255.142.07.325-.1.466h.169c.085.282-.113.565-.226.8s.3.142.127.226l-.113-.07c.085.24-.142.381-.127.611h0l-.212.085h0v.127h0s-.085.1,0,.142,0,.142-.142.155-.127,0,0,.169c-.113-.113-.183,0-.169.1s-.07,0-.1-.07,0,.085,0,.142c-.183,0,0,.255-.255.1a1.073,1.073,0,0,1-.3.4c0-.142.142-.1,0-.24-.07.142-.1.282-.24.306s0-.07,0-.1-.255.085-.339.212h0s-.07,0,0,.07h0c.07.085,0,.24,0,.3,0-.212-.142,0-.127-.3a.113.113,0,0,0,0,.1v-.085c0-.085,0,.113-.113.127s0,0,0-.085,0,.142-.127.127h0s-.2.212-.339.155,0,0,0-.183h-.07s-.113.085-.169,0h-.056c-.07,0,0,.155-.1.127s0,0-.085-.1h0s-.07.085-.127,0,0-.142,0-.169-.142,0-.212.113a.225.225,0,0,0,0-.113v.085a.085.085,0,0,1,0-.1c-.085,0,0,.169-.1.07h0a.6.6,0,0,1-.3-.07c-.085-.07.1,0,.1-.127s-.325,0-.438,0h0c-.1.155,0-.127-.142-.085s.07-.07,0,0-.183,0-.339-.085h0c0-.07-.1-.113-.142-.155s0,0-.085,0c0-.306-.381-.113-.325-.407h0l-.127-.07v.113a.127.127,0,0,1-.127,0c.085,0,.1-.085.113-.142h0s-.142.1-.127,0h0c.056,0-.212,0-.155-.085H25.3v-.142h0v-.056c-.255.07-.127-.1-.306-.113h.183a.212.212,0,0,1,.07-.085c-.1,0,0-.085-.113-.085s0,0,.07-.07,0,0-.1,0,.07-.24-.127-.3a.408.408,0,0,1-.268-.156h0a.212.212,0,0,1,.113,0,.127.127,0,0,0,0-.155H24.9s-.127,0-.085-.07h.142l-.142-.339h.142a.381.381,0,0,0-.1-.113s0,.07,0,.085h0c-.2.07,0,.155,0,.226h-.183a4.239,4.239,0,0,1,0-.593h.142ZM26.548,19.733Zm.085-.142h0s-.014,0,0-.014ZM24.7,23.066Zm.113.424h.014Zm.833,1.412h.07v.07Zm6.239,1.54v-.073h0Zm1.412-2.231h-.113V24.1a.142.142,0,0,1,.117.113Zm.2-.664a.127.127,0,0,1-.1,0,.394.394,0,0,0,0-.127ZM30.666,17.332Zm-.142,0Z",
    transform: "translate(-0.419 -0.781)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137706",
    "data-name": "Path 137706",
    d: "M30.16,21.32h0Z",
    transform: "translate(2.946 0.909)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137707",
    "data-name": "Path 137707",
    d: "M25.3,16.834v.014l.029-.029Z",
    transform: "translate(0.942 -0.946)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137708",
    "data-name": "Path 137708",
    d: "M29.84,22.81Z",
    transform: "translate(2.814 1.524)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137709",
    "data-name": "Path 137709",
    d: "M25,24.88Z",
    transform: "translate(0.818 2.376)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137710",
    "data-name": "Path 137710",
    d: "M26.72,24.87a.142.142,0,0,1-.07,0S26.735,24.926,26.72,24.87Z",
    transform: "translate(1.499 2.373)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137711",
    "data-name": "Path 137711",
    d: "M23.34,23.994Z",
    transform: "translate(0.134 2.006)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137712",
    "data-name": "Path 137712",
    d: "M30.31,21.33l.014.029v-.014Z",
    transform: "translate(3.007 0.913)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137713",
    "data-name": "Path 137713",
    d: "M30.275,21.83h0s-.127.127-.07.183S30.275,21.9,30.275,21.83Z",
    transform: "translate(2.958 1.119)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137714",
    "data-name": "Path 137714",
    d: "M27.5,24.75H27.42Z",
    transform: "translate(1.816 2.323)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137715",
    "data-name": "Path 137715",
    d: "M24.84,28.34Z",
    transform: "translate(0.752 3.803)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137716",
    "data-name": "Path 137716",
    d: "M29.022,30s-.169,0,0,.1S29.022,30,29.022,30Z",
    transform: "translate(2.445 4.487)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137717",
    "data-name": "Path 137717",
    d: "M24.82,28.33Z",
    transform: "translate(0.744 3.799)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137718",
    "data-name": "Path 137718",
    d: "M20.73,33.57l.085.085Z",
    transform: "translate(-0.942 5.959)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137719",
    "data-name": "Path 137719",
    d: "M25.28,28.23v.1c0,.029.085,0,.1,0Z",
    transform: "translate(0.933 3.757)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137720",
    "data-name": "Path 137720",
    d: "M25.274,28.3Z",
    transform: "translate(0.926 3.787)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137721",
    "data-name": "Path 137721",
    d: "M31.06,34.944l.029.014-.014-.029Z",
    transform: "translate(3.316 6.521)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137722",
    "data-name": "Path 137722",
    d: "M23.29,28.4Z",
    transform: "translate(0.114 3.828)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137723",
    "data-name": "Path 137723",
    d: "M18.42,33Z",
    transform: "translate(-1.894 5.724)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137724",
    "data-name": "Path 137724",
    d: "M19.07,31A.24.24,0,0,1,19,31Z",
    transform: "translate(-1.655 4.9)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137725",
    "data-name": "Path 137725",
    d: "M20.18,33.48h0l.014.014Z",
    transform: "translate(-1.169 5.923)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137726",
    "data-name": "Path 137726",
    d: "M25.279,28.394V28.38l-.029.014Z",
    transform: "translate(0.921 3.819)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137727",
    "data-name": "Path 137727",
    d: "M24.713,28.361h0s-.183-.085-.24,0S24.614,28.389,24.713,28.361Z",
    transform: "translate(0.597 3.797)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137728",
    "data-name": "Path 137728",
    d: "M19.69,30.313l.1-.014-.029-.1Z",
    transform: "translate(-1.371 4.57)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137729",
    "data-name": "Path 137729",
    d: "M16.815,31.768v.2a.424.424,0,0,0,.142-.4h.07c.07,0,0-.268-.183-.24s0,.142.1.3S16.857,31.8,16.815,31.768Z",
    transform: "translate(-2.577 5.035)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137730",
    "data-name": "Path 137730",
    d: "M17.121,30.66a.183.183,0,0,0,0,.085h0Z",
    transform: "translate(-2.432 4.76)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137731",
    "data-name": "Path 137731",
    d: "M19.1,35.519v-.1S18.826,35.476,19.1,35.519Z",
    transform: "translate(-1.666 6.722)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137732",
    "data-name": "Path 137732",
    d: "M17.14,30.64Z",
    transform: "translate(-2.422 4.751)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137733",
    "data-name": "Path 137733",
    d: "M30.8,28.78a.3.3,0,0,0,0,.155h0Z",
    transform: "translate(3.206 3.985)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137734",
    "data-name": "Path 137734",
    d: "M17.027,31.24h-.085c-.014,0,0,.113,0,.142Z",
    transform: "translate(-2.507 4.999)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137735",
    "data-name": "Path 137735",
    d: "M17,31.21Z",
    transform: "translate(-2.48 4.987)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137736",
    "data-name": "Path 137736",
    d: "M40.255,36.679h0v-.226c0-.085,0,.127-.085,0a26.094,26.094,0,0,0-.565-2.825c-.127-.339-.381,0-.424-.523h.155a12.993,12.993,0,0,0-1.2-1.61h.113c0-.183-.325-.452-.381-.407s0,0,0-.127-.306-.212-.3-.339h.07c-.1,0-.3-.354-.306-.212-.127-.226-.367-.339-.466-.523s-.3-.339-.424-.255c.127-.113-.255-.4-.438-.452.07,0-.07-.127,0-.127-.142-.127-.3-.2-.325-.113-.169-.367-.65-.282-.677-.593-.509-.24-.975-.438-1.412-.621.085-.142.494.24.551.085a9.271,9.271,0,0,1-1.158-.381h.142a8.263,8.263,0,0,0-1.271-.407h.1c-.085,0-.183-.085-.183,0h.07c.1.127-.367.113-.4.155.183-.155-.381-.155-.1-.354,0,0-.127,0-.127.07s-.1-.07,0-.1h-.48a.111.111,0,0,0,.1-.07.833.833,0,0,1-.494,0h0a7.142,7.142,0,0,1-1.087,0c.142-.142-.127-.07-.142-.212h-.706c-.212,0,0,.169-.255.127a.547.547,0,0,1-.3-.085h0a.523.523,0,0,1-.339,0v-.169c0-.029-.466,0-.579.183s0-.113,0-.113l-.07.085c-.085,0-.113,0-.1-.085-.268,0,.1.155-.226.113h0c-.325,0-.621.127-.917.142s.255-.07.127-.169c-.424.085-.862.325-1.271.4h.085c0,.183-.339,0-.509.142s0-.113,0-.1a3.517,3.517,0,0,0-.946.452v-.07c-.183,0-.424.169-.611.212s-.127.113,0,.142c-.636,0-.875.65-1.412.72,0,0,.1-.113,0-.085l-.325.282h.183a.677.677,0,0,1-.183.24c.127-.155-.085-.113-.169-.1s0,0,0,.07c-.268,0,0,.155-.24.255h0a1.272,1.272,0,0,1-.212.268c-.1,0,0-.113,0-.183s-.142.367-.325.4l.155-.212a.452.452,0,0,0-.3.142h0l-.24.169h0c0,.325-.282.339-.381.664.085-.306,0-.1-.085-.183s-.183.085-.183,0c0,.169-.2.127-.24.367,0,0-.1.1-.142,0-.1.155.07,0,.1,0-.1.282-.537.424-.636.848a6.258,6.258,0,0,0-.169.706h0c-.085,0,0-.142,0-.142a.749.749,0,0,0-.226.4h-.113c-.113,0,0,.142,0,.268a.452.452,0,0,1-.07-.183.965.965,0,0,1-.085.48c-.085.155,0-.127,0-.2a3.965,3.965,0,0,0-.085.4.183.183,0,0,1,.155-.183v.12c.226,0,.155-.424.282-.621l.07.127a9.024,9.024,0,0,0-.65,1.6h0l-.155-.07-.1-.1v.155h0c-.07,0-.155,0-.255.2v.268l-.1.07v-.212c-.1.1,0,.2,0,.3a.127.127,0,0,0-.1.085l.1.282s-.1-.142-.169,0,.169-.1.183.1-.142.085-.1.226,0,0-.07-.07,0,.354.085.424,0,.466-.113.48a1.412,1.412,0,0,1,.2.339c-.24-.183.127.48,0,.48.2.113.354.565.636.749h-.07s.1.212.155.325.325.085.494.1c.085.24-.2,0-.226.2,0-.1.367.127.367,0,.1.155.1.113.113.255.113-.142.156,0,.325,0s0,.169.268.212-.142.07-.142.07c.268.085.155-.085.24-.142.306,0,.113.127.212.226h.155a.99.99,0,0,1,.325,0h0a2.386,2.386,0,0,0,.776,0h0a.24.24,0,0,1,0-.169h.24c0,.142-.155,0-.169.113a1.949,1.949,0,0,1,.636,0c0,.127-.381,0-.183.127l-.255-.085c.169.212-.142,0,0,.183s.381,0,.706.085c.085,0,0-.1.07-.155.494,0,.325.354.692.255.113,0,.169-.212.4-.1l-.1.127c.306,0,.212-.169.537,0h.113v.113H23.81s-.1,0,0,.1a5.649,5.649,0,0,1,1.412.325l.2-.085h0c.169,0,0,0,.113-.085s.127.085,0,.1a2.824,2.824,0,0,1,1.243.113h0c.255.085.339-.169.565,0h0a7.611,7.611,0,0,1,1.6.367c.113-.142.551.156.621,0a2.513,2.513,0,0,0,.65.325c.113,0,.2-.1.353-.1v.1h.226l.085.142h.142s-.113-.07-.1-.1a.692.692,0,0,1,.523.212h.354c.3,0,0,.127.3,0v-.092a1.5,1.5,0,0,0,.621.142h0c.381.085.815.1,1.257.169-.155,0-.1-.183,0-.183v.127c.1,0-.113,0,0-.127s.1.155,0,.169h.2v.085c0,.085.306.169.452,0h0a2.723,2.723,0,0,1,.988.113c0-.1.156,0,.282-.127a2.26,2.26,0,0,0,.932.155c.255-.07,0-.085.169-.155s.381,0,.212.113a2.445,2.445,0,0,0,.988-.452h.1c.424-.367,1.257-.72,1.324-1.286h0a3.176,3.176,0,0,0,.127-.494c.085-.212,0,.155.113,0a4.9,4.9,0,0,0,.142-1.271C40.453,37.907,40.128,37.144,40.255,36.679Zm-11.5-7.768h-.353v-.1Zm-.452,0a.085.085,0,0,1,0-.1h.142Zm-4.35.72-.07.085h0Zm12.471,4.237-.07-.142h.07c.07,0,0,.169,0,.226Zm-.169-.306h0v-.07Zm-6.426-4.6a.509.509,0,0,0,0,.155h0l-.07.1h.113a.268.268,0,0,0,.142.226h.212v.085h-.155c.07.1.142,0,.226,0a.113.113,0,0,0,0,.1l.226-.1c0,.07-.113.1,0,.169s0-.169.113-.169,0,.142.142.113l-.07.07h.306c.07,0,.306.07.255.212a.579.579,0,0,1,.282,0c-.226.127.3.127.183.3.169-.1.407.1.636.113H32.3c.1.07.113.127.169.183s.24,0,.367-.085-.155.1-.169.24c0-.113.268,0,.268-.085V30.8c.1-.142.1,0,.226,0,.1.169,0,.169.127.212s-.127,0-.127,0a.284.284,0,0,0,.212-.1c.07-.1,0,.127,0,.226s.268,0,.354.07h0a1.426,1.426,0,0,0,.537.255h0a.611.611,0,0,1,.1-.142c.07,0,.169,0,.142.113a.085.085,0,0,0-.1,0h.085c0,.155-.113,0-.169,0,.155.07.354.127.424.24s-.24-.169-.183,0L34.45,31.5c0,.24-.085-.085-.113.155s.255.142.4.339,0-.085.142-.085c.354.169,0,.407.282.494s.24-.085.3.113H35.3c.142.183.255,0,.339.24,0,0-.155-.127-.142-.085a1.993,1.993,0,0,0,.2.24v.142a7.956,7.956,0,0,1,.565.611h-.1a2.217,2.217,0,0,1,.407,1.019l.156.085h.127c.127,0,0,.127-.07.085a1.313,1.313,0,0,1,.354.862h0c0,.2.255.169.212.367h0a2.825,2.825,0,0,1,0,1.229c.169,0,0,.424.169.438-.1.255-.142.183-.212.509,0,0,.113.1.113.183h-.1a.51.51,0,0,1,0,.127h-.124c0,.142-.24.127-.255.07a.48.48,0,0,1-.183.142.611.611,0,0,1,0-.1c-.085.127,0-.113-.1,0a.156.156,0,0,1,0,.085.72.72,0,0,0-.466-.1h0a2.155,2.155,0,0,0-.875-.1c.113,0,.07.183,0,.183v-.127c-.07,0,.1,0,0,.127s-.07-.142,0-.169h-.169v-.085c0-.085-.24-.155-.354,0h-.776c0,.1-.127,0-.226.127a2.5,2.5,0,0,0-.65-.212c-.169,0,0,.07-.142.127s-.255-.127-.113-.169a4.083,4.083,0,0,0-.749,0s.07,0,0,.1-.142-.07-.127-.113h0c-.438.07-.917-.407-1.271-.282h-.353c-.155,0,.1,0,0-.127-.4.1-.579-.113-.9,0-.2-.3-.833-.113-1.13-.339v.07c-.1,0-.1,0-.155-.07s.085.07,0,.085a11.582,11.582,0,0,1-2.125-.49c-.255,0-.2.3-.509.1l.113-.1c-.537,0-1.074-.169-1.61-.142h.1c.1,0-.407-.07-.407,0v-.1c0-.1-.3,0-.339,0h0c-.07,0-.325-.07-.282,0-.183-.085-.367,0-.523-.1s-.306-.1-.367,0c0-.155-.325-.183-.452-.127s-.1,0,0-.127-.282,0-.268.085c-.226-.226-.537.07-.65-.2H19.678c0-.155.408,0,.424-.127-.354,0-.677.142-.763,0s0,0,.085,0c-.183,0-.113-.169-.155-.509h0v-.142h0c-.127.085-.183-.255-.24-.282.183.142.113-.282.339-.07,0,0,0-.1-.07-.1h.1c0-.212-.085-.155,0-.339s0,0,.07.085a.452.452,0,0,1,0-.381h0c.085-.268,0-.523.2-.776.1.142.1-.07.212,0v-.157h-.085c.07-.127,0-.282.155-.381v.126l.113-.255-.127.113c0-.169-.142-.07,0-.226s.1-.127.2-.142h0a.282.282,0,0,1,.113-.255s.1.113.142.113a.639.639,0,0,0,.142-.438c-.029-.142,0,.085.07.085v-.1h.127c.043,0-.183,0,0-.2v.07c.2-.169.282-.4.48-.523s-.113.155,0,.183a4.238,4.238,0,0,1,.65-.763h0c-.085-.169.24-.07.306-.24s0,.113,0,.085a3.05,3.05,0,0,0,.579-.523v.07c.127,0,.3-.155.424-.212s.085-.085,0-.127c.494,0,.664-.509,1.121-.438,0,0-.085.085,0,.07l.3-.155c0-.07,0,0-.156-.07a.339.339,0,0,1,.183-.155c-.127.1,0,.127.113.155s0,0,0-.085c.2.085,0-.169.226-.142h0a1.414,1.414,0,0,1,.24-.142h0c0,.085-.085.07,0,.155s.212-.24.353-.183l-.183.1a.4.4,0,0,0,.268,0h.183c.1-.282.306-.127.509-.306-.2.183,0,.085,0,.2s.155,0,.127.07.183,0,.306-.1.113,0,.1.085,0,0,0-.1.494.085.776-.085a1.386,1.386,0,0,1,.509-.212h0l-.085.113a.65.65,0,0,0,.367,0v.1c0,.1.07-.127.2-.07a.424.424,0,0,1-.1.142,3.29,3.29,0,0,1,.353-.1.548.548,0,0,1-.127.113h.3a.1.1,0,0,1-.155-.085h.085a.113.113,0,0,0-.07-.07h.48a.185.185,0,0,0-.142.24c.085-.113.1,0,.212-.183s.113,0,.085.1.1,0,.155,0a.212.212,0,0,0-.306-.07s0,0,0-.07h.468Zm-2.5-.155h.085Zm-5.494-.636a.141.141,0,0,1,0,.07l-.127.07s.056.014.127-.056Zm-3.418,3.107h.113a1.071,1.071,0,0,0-.113.156.268.268,0,0,1,0-.07Zm-.664,1.031a.1.1,0,0,1,.1,0,.86.86,0,0,0-.1.2ZM24.013,39.593Zm.255,0h0a.182.182,0,0,1,.142.085Z",
    transform: "translate(-2.814 2.992)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137737",
    "data-name": "Path 137737",
    d: "M26.493,36.679V36.65l-.043.014Z",
    transform: "translate(1.416 7.229)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137738",
    "data-name": "Path 137738",
    d: "M18.37,29Z",
    transform: "translate(-1.915 4.075)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137739",
    "data-name": "Path 137739",
    d: "M27.35,26.82h0C27.463,26.834,27.406,26.82,27.35,26.82Z",
    transform: "translate(1.787 3.177)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137740",
    "data-name": "Path 137740",
    d: "M24.49,26.527h.127S24.49,26.47,24.49,26.527Z",
    transform: "translate(0.608 3.046)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137741",
    "data-name": "Path 137741",
    d: "M30.24,28.3h0l.029.014Z",
    transform: "translate(2.978 3.787)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137742",
    "data-name": "Path 137742",
    d: "M16.889,31.16l-.029.029.014.014Z",
    transform: "translate(-2.538 4.966)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137743",
    "data-name": "Path 137743",
    d: "M17.452,30.23a.777.777,0,0,0-.212.255h0C17.24,30.428,17.466,30.329,17.452,30.23Z",
    transform: "translate(-2.381 4.582)",
    fill: "#0c3058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137744",
    "data-name": "Path 137744",
    d: "M23.13,26.6l.169-.056-.127-.043Z",
    transform: "translate(0.047 3.045)",
    fill: "#0c3058"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_13318",
    "data-name": "Path 13318",
    d: "M.2,5.257c.291,0-.146.2,0,.336s-.157,0-.123,0,.067.381.157.661H.168c-.067.112,0,.291-.078.4s.067.1.179.067c-.437.358.224.695-.134,1.019,0,0-.067-.09-.067-.067l.067.28c.134,0,.078,0,.179-.09a.235.235,0,0,1,.146.179c-.09-.123-.213,0-.28.056s.078,0,.123,0c-.235.146.246,0,.1.224H.358c0,.078.134.146.123.224S.4,8.483.28,8.483s.314.19.179.314S.392,8.685.347,8.651C.19,8.786.235,8.8.224,8.9h0v.157c.415,0,.168.291.482.37-.3-.067-.134,0-.3.09s0,.168-.078.168c.168,0,0,.213.235.235,0,0,.056.09-.067.146.112.09.056-.078.123-.1.258,0,.112.538.527.56a1.454,1.454,0,0,0,.583,0h0c0,.09-.146.112-.146.112a.235.235,0,0,0,.269.168v.146c0,.067.146-.146.224,0a.639.639,0,0,1-.179.168.808.808,0,0,0,.392-.067c.123-.067-.112.112-.168.157a.673.673,0,0,0,.291,0c-.123,0-.123-.1-.112-.157h.09c0-.325-.314,0-.459-.134l.134-.157A2.576,2.576,0,0,0,3.182,11h0a2.171,2.171,0,0,0,0,.269h0l-.056.179h.1a.426.426,0,0,0,.168.314l.157-.157v.123H3.417c.078.112.123,0,.179-.067a.258.258,0,0,0,.067.146l.168-.258c0,.112-.078.213,0,.269.078-.123-.078-.235,0-.314.078.123.056.224.157.123a.134.134,0,0,1,0,.134c.078-.078.213,0,.258-.168.078.146.269,0,.269.2a.459.459,0,0,1,.213-.2c-.134.291.28,0,.246.336.1-.269.37-.123.549-.269v.056c0-.011.123.1.19.146,0-.213.168-.269.258-.4.123.213-.078.258,0,.459,0-.179.213-.179.168-.325.1.134.078.067.134.246,0-.269.09,0,.168-.213.134.134,0,.258.179.168.078.09-.056.19-.056.19s.067-.213.1-.325.09.146.146.258c.112-.056.2-.246.291-.235s0,0,0,.09c.123-.168.358,0,.5-.213a1.276,1.276,0,0,1,0-.28c.078,0,.134-.134.157,0s0,0-.067.1l.078-.067c0,.2-.1.067-.1.213.134-.067.3-.224.415-.168s-.258.067-.112.235l-.168-.078c.134.3-.1,0,0,.3.213.056.235-.1.459,0v-.258c.314-.19.246.482.471.224,0-.123.078-.37.246-.235l-.056.213c.213,0,.123-.314.347-.168,0,.09-.168.078-.134.1s.1-.123.213-.123l-.034-.09a7.035,7.035,0,0,0,.717-.2v.168a8.739,8.739,0,0,1,1.232-.09,1.2,1.2,0,0,0,.078-.213.07.07,0,0,1,.067.09c-.011.09,0-.1,0-.19s.134,0,.112.1c.19-.235.448-.616.751-.672v.067c.2-.1-.09-.4.146-.437h0c.358-.3.426-.8.762-1.042-.2-.123.213-.426-.123-.515.2-.213.246-.168.37-.5,0-.078-.2-.123-.235-.224h.168l-.179-.134L13.4,7.62v-.1a.146.146,0,0,1-.134.078c-.078-.146.123-.358.213-.358L13.309,7c.067,0,.09.067.134.112-.179-.179.179,0,0-.2h-.134a.415.415,0,0,0,.056-.415h.123V5.682c-.056.1-.258.078-.28,0h.179c-.112,0-.067.09-.2,0s.2-.067.258,0V5.559h.146c-.112,0,.19-.224,0-.3h.056c0-.28-.056-.414-.067-.65-.157,0-.123-.09-.258-.157a1.68,1.68,0,0,0,.168-.571c-.078-.146-.134,0-.235-.112.146,0,.134-.224.235-.1a1.423,1.423,0,0,0-.235-.751s-.056.1-.112.09a.134.134,0,0,1,.09-.168h0c-.157-.168-.134-.426-.157-.683s-.1-.5-.325-.549h0c-.112-.067-.235-.112-.347-.168s.146,0,.123-.157c-.437-.09-.448-.437-.807-.471,0-.515-.818-.336-1.12-.627v.1a.148.148,0,0,1-.157-.168c0-.034.078.1,0,.146A3.439,3.439,0,0,1,9.455.2c-.3-.067-.6-.157-.907-.2s-.134.515-.4.28L8.223.1C7.775.316,7.3.1,6.867.283c0,0,0-.1.078-.1s-.347,0-.347.1,0-.1-.056-.157-.235.179-.28,0h0s-.28,0-.224.134C5.87.193,5.725.327,5.59.26c-.078.179-.28-.078-.3.168C5.288.171,5,.215,4.9.339,4.9.26,4.806.26,4.84.148s-.224,0-.2.19c-.213-.3-.437.235-.56-.146a5.286,5.286,0,0,1-.986.28c0-.246.347,0,.336-.291A2.24,2.24,0,0,1,2.577.5c-.1,0,0-.123.056-.168-.336.146-.717.134-.952.4a.179.179,0,0,1,0-.09c-.056,0-.146,0-.09.134V.72c.157.112-.056.414,0,.5C1.512.888,1.3,1.3,1.21.865a.179.179,0,0,0,0,.179.1.1,0,0,1-.1-.112c-.146.19,0,.224-.157.358V1.145A.379.379,0,0,1,.8,1.526c-.157.1-.067,0,0-.09-.2.235-.09.549-.325.751-.168-.19-.123,0-.314,0v.19H.28c-.067.134,0,.3-.067.4V2.646a2.386,2.386,0,0,0,0,.28L.325,2.8c.067.157.258.056.157.213,0,0,0,.123-.168.179h0c.056.078.112.146.056.246s-.224,0-.269,0c.168.078,0,.336.224.4a.56.56,0,0,0-.179,0L.291,3.9c0,.056-.067.067-.157.056,0,.179.258-.056.146.157H.224c-.056.213.09.415,0,.6s0-.168-.224-.1c0,.28.246.583.2.851Zm1.12,2.655a.146.146,0,0,1,.134.078H1.322Zm0-2.621a.369.369,0,0,1,.134.067H1.322Zm0-.717.146.1a.3.3,0,0,1-.146,0ZM6.554,2.165H6.43V2.053l.112.112ZM6.285,2.165Zm-5.1,8,.067-.112.09.067a.258.258,0,0,1-.168.056Zm.661.5a.2.2,0,0,1,.067-.146l.112.056Zm8.212.583Zm.2,0v-.112a.813.813,0,0,0,.123.1ZM.471,7.273v.09a.179.179,0,0,1-.134-.09.539.539,0,0,1,.134,0Z",
    transform: "translate(70.701 31.029) rotate(8)",
    fill: "#2d82f7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiometricIcon2);
export default __webpack_public_path__ + "static/media/biometric-icon_2.59f51f49e69b08e363ad99dcae8ef7e9.svg";
export { ForwardRef as ReactComponent };